import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import domainModel from 'domain-model';
import Image from '../Image';

function ArticleImage({
  article,
  alt,
  resX,
  resY,
  className,
  png,
  style,
  showFaultyImageIndicator,
}) {
  const articleImage = article.image || _.get(article, 'images[0]');

  if (articleImage === 'NA' && showFaultyImageIndicator) {
    return (
      <Image
        src={articleImage}
        alt={alt}
        className={className}
        resY={resY}
        resX={resX}
        png={png}
        style={style}
      />
    );
  }

  if (!articleImage || !domainModel.article.isFlaivyAssetImage(articleImage)) {
    let categoryFallbackImage = `https://assets.flaivy.com/${resX}x${resY}/b3f2834cf763bdb714f48eb3e8e59723.png`;
    try {
      categoryFallbackImage = domainModel.article.getFallbackImage(article);
    } catch (e) {
      // we don't want to log these errors
    }

    return (
      <Image
        src={categoryFallbackImage}
        alt={alt}
        className={className}
        resY={resY}
        resX={resX}
        png={png}
        style={style}
      />
    );
  }

  return (
    <Image
      src={articleImage}
      alt={alt}
      className={className}
      resY={resY}
      resX={resX}
      png={png}
      style={style}
    />
  );
}

ArticleImage.propTypes = {
  article: PropTypes.object,
  alt: PropTypes.string,
  png: PropTypes.bool,
  resX: PropTypes.number,
  resY: PropTypes.number.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  showFaultyImageIndicator: PropTypes.bool,
};

ArticleImage.defaultProps = {
  article: {},
  alt: '..',
  className: '',
  resX: undefined,
  png: false,
  style: undefined,
  showFaultyImageIndicator: false,
};
export default ArticleImage;
